import { useState, type ReactNode } from 'react';
import { managerApi } from '../lib/api';
import { errorMessage } from './ErrorModalBody';

const SESSION_KEY = 'coala.ownerSenha';

/** Portão extra para áreas mais sensíveis do painel (Documentação, Backup) —
 * uma única senha, que pode ser a senha especial (a mesma de trocar o tipo
 * de horário) ou qualquer senha mestre válida. Fica "destravado" só durante
 * a sessão do navegador (sessionStorage), não persiste entre visitas. */
export function OwnerGate({ children }: { children: (senha: string) => ReactNode }) {
  const [senhaOk, setSenhaOk] = useState<string | null>(() => sessionStorage.getItem(SESSION_KEY));
  const [senha, setSenha] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function unlock() {
    setError('');
    setBusy(true);
    try {
      const trimmed = senha.trim();
      await managerApi.verifyOwnerAccess(trimmed);
      sessionStorage.setItem(SESSION_KEY, trimmed);
      setSenhaOk(trimmed);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  if (senhaOk !== null) return <>{children(senhaOk)}</>;

  return (
    <div className="card">
      <h2>Área restrita</h2>
      <p className="hint">Digite a senha para acessar.</p>
      <label>Senha</label>
      <input type="password" value={senha} onChange={(e) => setSenha(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') unlock(); }} />
      {error && <div className="err">{error}</div>}
      <button className="btn btn-primary btn-block" style={{ marginTop: 14 }} disabled={busy} onClick={unlock}>Desbloquear</button>
    </div>
  );
}
